import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateStep, Step, StepListResponse, StepQueryParams, UpdateStep } from '@frontend/wizard/types';

export class StepClient extends APIClient {
    public static readonly endpoint = '/wizard-api/v1';

    public static async fetchSteps(queryParams?: ApiQueryParams<StepQueryParams>): Promise<StepListResponse> {
        return await this.apiPaginated<StepListResponse, StepQueryParams>(`${this.endpoint}/steps`, queryParams);
    }

    public static async resolveSteps(ids: string[], field: string = 'id'): Promise<StepListResponse> {
        return this.resolve<StepListResponse>(`${this.endpoint}/steps`, ids, field);
    }

    public static async deleteSteps(stepIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/steps-delete`, { ids: stepIds });
        return await this.handleVoidResponse(response);
    }

    public static async postStep(accountId: string, wizardId: string, step: CreateStep): Promise<Step> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}/steps`, step);
        return await this.handleResponse<Step>(response);
    }

    public static async fetchStep(accountId: string, wizardId: string, stepId: string): Promise<Step> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}/steps/${stepId}`);
        return await this.handleResponse<Step>(response);
    }

    public static async patchStep(accountId: string, wizardId: string, stepId: string, step: UpdateStep): Promise<Step> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}/steps/${stepId}`, step);
        return await this.handleResponse<Step>(response);
    }

    public static async deleteStep(accountId: string, wizardId: string, stepId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}/steps/${stepId}`);
        return await this.handleVoidResponse(response);
    }
}
